<template>
  <modal :title="'Form Needs Parts'" @close="$emit('close')">
    <template #content>
      <load-area v-if="data == null"></load-area>

      <dataTable
        :name="'CustomerProviderHotelCodes'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="[{ Tag: 'All Form Needs Parts' }, ...data]"
        v-if="data != null"
        :rowClassRules="{
          // row style function
          process: (params) => {
            // var numSickDays = params.data;
            return params?.data?.isLoad == true;
          },
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.isSuccess == true;
          },
          danger: (params) => {
            // var numSickDays = params.data;
            return params?.data?.isError == true;
          },
        }"
        @update="update"
      ></dataTable>
    </template>
  </modal>
</template>

<script>
export default {
  name: "TempReservation",
  props: ["hotel"],
  data() {
    return {
      columnDefs: [
        {
          headerName: "Tag",
          field: "Tag",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 160,
          cellRenderer: function(params) {
            if (params.value == "All Form Needs Parts") {
              return "<b style='font-weight:600'>" + params.value + "</b>";
            } else {
              return params.value;
            }
          },
        },
        {
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text:
                '<span>Güncelle</span><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"></circle></svg>',
              emit: "update",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      process: false,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get("Softwares/" + this.hotel.SoftwareId + "/FormParts")
      .then((response) => {
        let dt=response.data;
        if(this.hotel.SoftwareId==13){
          dt.push({SoftwareId:13,Tag:'DiscountReasons'});
          dt.push({SoftwareId:13,Tag:'ManualPromotions'});
        }
        console.log("dt",dt);
        this.data = dt;
      })
      .catch((err) => {
        this.$isError(err);
      });
  },
  methods: {
    update(item) {
      if (item.isLoad != true) {
        if (item.Tag == "All Form Needs Parts") {
          this.updateAll(item);
          return false;
        }
        this.$refs.agGrid.changeRow("Tag", {
          ...item,
          isLoad: true,
          isError: false,
          isSuccess: false,
        });
        this.$appAxiosAdmin
          .get("pms/" + this.hotel.SoftwareId + "/UpdateFormPart/" + this.hotel.Id + "/" + item.Tag)
          .then(() => {
            this.$refs.agGrid.changeRow("Tag", {
              ...item,
              isLoad: false,
              isSuccess: true,
            });
          })
          .catch((err) => {
            this.$refs.agGrid.changeRow("Tag", {
              ...item,
              isLoad: false,
              isError: true,
            });
            this.$isError(err);
          });
      }
    },
    updateAll(item) {
      if (item.isLoad != true) {
        this.$refs.agGrid.changeRow("Tag", {
          ...item,
          isLoad: true,
          isError: false,
          isSuccess: false,
        });
        this.$appAxiosAdmin
          .get("pms/" + this.hotel.SoftwareId + "/UpdateReservationDetailFormNeeds/" + this.hotel.Id)
          .then(() => {
            this.$refs.agGrid.changeRow("Tag", {
              ...item,
              isLoad: false,
              isSuccess: true,
            });
          })
          .catch((err) => {
            this.$refs.agGrid.changeRow("Tag", {
              ...item,
              isLoad: false,
              isError: true,
            });
            this.$isError(err);
          });
      }
    },
  },
};
</script>

<style scoped>
/deep/ .process .btn {
  opacity: 0.65;
}
/deep/ .process .btn svg {
  opacity: 1;
}
/deep/ .process .btn span {
  opacity: 0;
}
</style>
